import { render } from "./GroupMaster.vue?vue&type=template&id=0e509e60&scoped=true"
import script from "./GroupMaster.vue?vue&type=script&lang=js"
export * from "./GroupMaster.vue?vue&type=script&lang=js"

import "./GroupMaster.vue?vue&type=style&index=0&id=0e509e60&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e509e60"]])

export default __exports__